<template>
  <v-flex>
    <v-btn
      v-if="searchToggle" 
      fab
      small
      color="gray darken-4"
      @click="toggleSearch"
    >
      <v-icon>search</v-icon>
    </v-btn>
    <v-flex v-else>
      <v-flex class="search-place" d-inline-flex align-baseline ml-2 pa-2>
        <v-text-field
          v-model="searchPlaceValue"
          label="Buscar punto de interés"
          style="width: 390px;"
          color="white"
          ref="search"
          flat
          solo
          clearable
          prepend-inner-icon="search"
          :disabled="searchDisabled"
          @keyup.enter="searchPlace"
        ></v-text-field>
        <v-progress-circular
          v-if="searchDisabled"
          class="ml-3"
          :size="28"
          :width="3"
          color="primary"
          indeterminate
        />
        <v-btn
          v-else
          fab
          small
          color="gray darken-4"
          @click="toggleSearch"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-flex>
      <v-flex v-if="resultPlacesDone === 1" class="list-container" mt-1 ml-2 pa-2>
        <h2>Resultados</h2>
        <v-flex
          v-for="(item, index) in resultPlaces"
          :key="index"
          class="list-item column"
          pa-1
          @click="sendToMap(item, index)"
        >
          <div class="d-flex">
            <div style="width: 400px">
              <div class="body-2">
                {{ item.name }}
              </div>
              <div class="caption">
                {{ item.formatted_address }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <div v-if="parentComp === 'base-vehicles'">
              <img
                v-if="index === indexSelected"
                :src="selectPointMarkerRed"
                height="32px"
                alt="marker"
              >
            </div>
            <div v-else>
              <img
                v-if="index === indexSelected"
                :src="selectPointMarker"
                height="32px"
                alt="marker"
              >
            </div>
          </div>
          <v-divider v-if="index < resultPlaces.lenght"></v-divider>
        </v-flex>
      </v-flex>
      <v-flex v-else-if="resultPlacesDone === 0" class="list-container">
        <h3>No se econtraron resultados</h3>
      </v-flex>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SELECT_POINT_MARKER, SELECTED_POSITION_MARKER_RED } from '../utils/staticsRef'

export default {
  name: 'place-searcher',
  props: ['map', 'parentComp'],
  data() {
    return {
      searchPlaceValue: null,
      searchDisabled: false,
      searchToggle: true,
      resultPlacesDone: null,
      resultPlaces: [],
      selectPointMarker: SELECT_POINT_MARKER,
      selectPointMarkerRed: SELECTED_POSITION_MARKER_RED,
      indexSelected: null,
      isFilteringToggle: false
    }
  },
  watch: {
    'map.center': {
      handler: function(newValue, oldValue) {
        if (this.placeSelected) {
          if (this.placeSelectedLocation !== newValue) {
            this.setPlaceSelected(false)
            this.setPlaceSelectedLocation(null)
            this.indexSelected = null
            this.$emit('outOfCenter')
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['placeSelected', 'placeSelectedLocation', 'searchVehicle', 'isFiltering'])
  },
  methods: {
    ...mapActions([
      'setPlaceSelected',
      'setPlaceSelectedLocation',
      'setLogHistoryFront',
      'setIsFiltering'
    ]),
    async searchPlace() {
      if (this.searchPlaceValue !== null) {
        this.resultPlacesDone = null
        this.resultPlaces = []
        this.searchDisabled = true
        this.indexSelected = null
        this.$emit('initSearchPlace')
        const result = await this.findPlaceQuery()
        this.searchDisabled = false
        // console.log('RESULT searchPlace', result)
        this.resultPlaces = result
        this.resultPlacesDone = this.resultPlaces.length > 0 ? 1 : 0

        setTimeout(() => {
          if (this.isFilteringToggle) {
            this.setIsFiltering(false)
            this.isFilteringToggle = false
          }
        }, 1000)
      }
    },
    toggleSearch() {
      this.searchToggle = !this.searchToggle
      this.searchPlaceValue = null
      this.resultPlacesDone = null
      this.resultPlaces = []
      // Checks if there is a current vehicle in search
      if (!this.searchVehicle) this.$emit('initSearchPlace')
    },
    findPlaceQuery() {
      this.setIsFiltering(true)
      this.isFilteringToggle = true

      const request = {
        query: this.searchPlaceValue,
        fields: ['name', 'geometry', 'formatted_address'],
        locationBias: {
          north: 6.36740048670079,
          south: 6.112604614964006,
          east: -75.66802638040043,
          west: -75.51576273904301
        }
      }
      let service = new google.maps.places.PlacesService(this.map)
      return new Promise((resolve, reject) => {
        service.findPlaceFromQuery(request, (results, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK && results) {
            resolve(results)
          }
        })
      })
    },
    sendToMap(item, index) {
      // Checks if there is a current vehicle in search
      if (!this.searchVehicle) {
        // Close the info window of any marker in map to avoid conflicts
        this.$emit('closeInfoWindow')
        // Se log to this action: Place Selected from the search result
        const dataAction = {
          name: item.name,
          addressSelected: item.formatted_address,
          location: item.geometry.location
        }
        const payload = {
          event: 'searched',
          eventDescription: 'finder',
          dataAction: dataAction,
          modelId: '',
          modelType: 'map_address',
          product: 'front-preloaded-data-filter'
        }
        this.setLogHistoryFront(payload)

        this.setPlaceSelected(true)
        this.setPlaceSelectedLocation(item.geometry.location)
        this.indexSelected = index
        this.$emit('toMap', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-place {
  background-color: #212121;
  border-radius: 2px;
  height: 65px;
}
.list-container {
  background-color: #212121;
  border-radius: 2px;
  width: 462px;
}

.list-item:hover {
  cursor: pointer;
  opacity: 0.75;
}

</style>


// WEBPACK FOOTER //
// src/components/PlaceSearcher.vue